import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../../../icon';

const NumberInput = (props) => {

    const handleNumberInput = (e) => {
        const value = e.target.value;

        // Only update if the input is a valid number
        if (!isNaN(value) || value === '.') {
            if (props.onChange) {
                props.onChange(value);
            }
        }
    };
    const inputRef = React.useRef(null);

    React.useEffect(() => {
        const handleKeyDown = (e) => {
            // Only handle if this input is focused
            if (document.activeElement !== inputRef.current) {
                return;
            }

            if (e.key === 'ArrowUp') {
                e.preventDefault();
                const currentValue = parseFloat(props.value) || 0;
                const increment = e.shiftKey ? 10 : 1;
                const newValue = currentValue + increment;
                if (props.onChange) {
                    props.onChange(newValue.toString());
                }
            } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                const currentValue = parseFloat(props.value) || 0;

                if (e.shiftKey) {
                    // For shift + arrow down
                    if (currentValue < 10) {
                        // If below 10, set to 0
                        if (props.onChange) {
                            props.onChange('0');
                        }
                    } else {
                        // Otherwise subtract 10, but don't go below 0
                        const newValue = Math.max(0, currentValue - 10);
                        if (props.onChange) {
                            props.onChange(newValue.toString());
                        }
                    }
                } else {
                    // For regular arrow down, don't go below 0
                    const newValue = Math.max(0, currentValue - 1);
                    if (props.onChange) {
                        props.onChange(newValue.toString());
                    }
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [props.value, props.onChange]);

    return (
        <div className={`number-input-wrapper-percentage ${props.center ? 'number-input-wrapper--center' : ''}`}>
            <div className="form-item suffix-inside--wrapper">
                <label htmlFor={props.label + props.suffix} className="form-item__label">
                    {props.label}
                </label>
                <div className='suffix-inside-input input-percentage-wrapper'>
                    <div className='input-percentage-wrapper-inner'>

                        <input disabled={props.locked} ref={inputRef} id={props.label + props.suffix} type="text" value={props.value} className={`input__input h-position-relative ${props.invalid ? 'error' : ''}`}
                            onChange={handleNumberInput}
                        />
                        <span className="suffix-inside">{props.suffix}</span>
                    </div>
                    <button
                        type="button"
                        className='input-percentage-wrapper-locked-button'
                        onClick={() => props.setLocked(!props.locked)}
                        aria-pressed={props.locked}
                        aria-label={props.locked ? `Unlock ${props.label} input field` : `Lock ${props.label} input field`}
                        title={props.locked ? `Unlock ${props.label}` : `Lock ${props.label}`}
                    >
                        <div className='input-percentage-wrapper-locked input__input' >
                            <Icon icon={props.locked ? 'lock-locked' : 'lock-unlocked'} additionalClasses="calculator-result__item--icon calculator-result__item--icon-white" />
                        </div>
                        <span className="h-hidden-from-view">
                            {props.locked ? 'Input is currently locked' : 'Input is currently unlocked'}
                        </span>
                    </button>

                </div>
            </div>
            {props.assistiveText &&
                <p className='assistive-text'>{props.assistiveText}</p>
            }
        </div >
    );
};

NumberInput.props = {
    id: PropTypes.string,
    center: PropTypes.bool,
    suffix: PropTypes.string,
    assistiveText: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    children: PropTypes.element,
    invalid: PropTypes.bool,
    locked: PropTypes.bool,
    onChange: PropTypes.func
};

export default NumberInput;
